import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import { TranslationKeys } from '@/localization';
import { FC, PropsWithChildren } from 'react';
import { PageBigTitle } from '../PageBigTitle';
import { twMerge } from 'tailwind-merge';

type PageListHeaderProps = {
  title: TranslationKeys;
  subtitle: TranslationKeys;
  breadcrumbs: BreadcrumbItem[];
  classNames?: {
    wrapper?: string;
  };
} & PropsWithChildren;

export const PageListHeader: FC<PageListHeaderProps> = ({ title, subtitle, breadcrumbs, classNames, children }) => {
  return (
      <header className={twMerge('grid gap-4', classNames?.wrapper)}>
        <Breadcrumbs items={breadcrumbs} />

        <div className='mb-6 flex items-start justify-between'>
          <PageBigTitle title={title} subtitle={subtitle}></PageBigTitle>
          <div className='flex flex-col items-end self-end'>
            {children}
          </div>
        </div>
      </header>
  );
};
